import { Flex, Icon, Tooltip } from "@chakra-ui/react";
import { FaAsterisk } from "react-icons/fa";

export default function RequiredIndicator({ required }: { required: boolean }) {
  if (!required) return null;

  return (
    <Tooltip hasArrow label="Required">
      <Flex pl={2} pr={2}>
        <Icon as={FaAsterisk} boxSize={"0.5em"} />
      </Flex>
    </Tooltip>
  );
}
